import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('div',{},[_c('cpLead',{attrs:{"pid":_vm.id,"pedit":_vm.pedit,"pnew":_vm.pnew},on:{"error":_vm.errorLead}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }